import { createSelector } from '@reduxjs/toolkit';

export const selectCompanies = state => state.entities.companies.data;
export const selectCompaniesAsArray = createSelector([selectCompanies], companies =>
  Object.values(companies)
);
export const selectIsLoadingCompany = state => state.entities.companies.isLoading;
